import { render, staticRenderFns } from "./CategoryTab.vue?vue&type=template&id=5a069d00&scoped=true"
import script from "./CategoryTab.vue?vue&type=script&lang=js"
export * from "./CategoryTab.vue?vue&type=script&lang=js"
import style0 from "./CategoryTab.vue?vue&type=style&index=0&id=5a069d00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a069d00",
  null
  
)

export default component.exports